import { render, staticRenderFns } from "./batchChapter.vue?vue&type=template&id=04bf3cfe&scoped=true"
import script from "./batchChapter.vue?vue&type=script&lang=js"
export * from "./batchChapter.vue?vue&type=script&lang=js"
import style0 from "./batchChapter.vue?vue&type=style&index=0&id=04bf3cfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bf3cfe",
  null
  
)

export default component.exports